<template>
  <v-card
    elevation="3"
    class="auth-card"
  >
    <div class="d-flex flex-column align-center pa-8">
      <v-img
        :src="brand.logo"
        width="200"
        class="mb-4"
      />

      <h1 class="text-h5 font-weight-medium text-center mb-1">
        Email Verification Required
      </h1>
      
      <p class="text-body-2 text-medium-emphasis text-center mb-8">
        Please check your email inbox and verify your email address to continue.
        Once verified, you can return to login.
      </p>

      <v-btn
        block
        color="primary"
        size="large"
        @click="emit('return')"
      >
        <v-icon start>
          mdi-login
        </v-icon>
        Return to Login
      </v-btn>

      <v-divider class="my-4 w-100" />

      <p class="text-caption text-medium-emphasis text-center">
        For support, contact
        <a
          :href="`mailto:${brand.supportEmail}`"
          class="text-decoration-none text-primary"
        >
          {{ brand.supportEmail }}
        </a>
      </p>
    </div>
  </v-card>
</template>

<script setup lang="ts">
import { brand } from '@/config/brand'

const emit = defineEmits<{
  return: []
}>()
</script>

<style scoped>
.auth-card {
  border-radius: 16px;
  max-width: 450px !important;
}

:deep(.v-field) {
  border-radius: 8px;
}
</style> 